/*******************************************************************************
Triggers an update to the winnings amounts displayed on a betting event card.
*******************************************************************************/

import updateWinnings from './update-winnings';

export default function triggerUpdateWinnings(e) {
    const $input = $(e.currentTarget);
    const eventID = Number($input.parents('.event').data('id')) || '';

    // We're converting to cents to potentially limit issues with JS and decimal values
    const centsBet = Math.round(Math.max(Number($input.val().replace(/[^0-9.]/g, '')) * 100, 0));

    // Get the multiplier values from the input data attributes
    const {
        mlHome, mlAway, spreadHome, spreadAway, ouOver, ouUnder, distanceYes, distanceNo, decisionFighter1, decisionFighter2, knockoutFighter1, knockoutFighter2, submissionFighter1, submissionFighter2
    } = $input.data();

    // Bundle all the multipliers into an object
    const multipliers = {
        ml    : { home: mlHome, away: mlAway },
        spread: { home: spreadHome, away: spreadAway },
        ou    : { over: ouOver, under: ouUnder },
        distance : { yes: distanceYes, no: distanceNo },
        decision : { fighter1: decisionFighter1, fighter2: decisionFighter2 },
        knockout : { fighter1: knockoutFighter1, fighter2: knockoutFighter2 },
        submission : { fighter1: submissionFighter1, fighter2: submissionFighter2 },
    };

    // Update the winnings on screen
    updateWinnings(eventID, centsBet, multipliers);
}
